import React, { useEffect, useRef, useState } from "react";
import "./Sort.css";
import "../Filter/Filter.css";
import { useTranslation } from "react-i18next";

const Sort = ({ options, onOptionSelect, defaultValue = "" }) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onOptionSelect(option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);

  const defaultSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="32"
        height="32"
        rx="5.5"
        fill="white"
        stroke="#CDCDCD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2928 13.7193C16.1053 13.5318 16 13.2775 16 13.0123C16 12.7471 16.1053 12.4928 16.2928 12.3053L19.2928 9.30529C19.385 9.20978 19.4954 9.1336 19.6174 9.08119C19.7394 9.02878 19.8706 9.00119 20.0034 9.00004C20.1362 8.99888 20.2678 9.02419 20.3907 9.07447C20.5136 9.12475 20.6253 9.199 20.7192 9.29289C20.8131 9.38679 20.8873 9.49844 20.9376 9.62133C20.9879 9.74423 21.0132 9.87591 21.012 10.0087C21.0109 10.1415 20.9833 10.2727 20.9309 10.3947C20.8785 10.5167 20.8023 10.627 20.7068 10.7193L17.7068 13.7193C17.5193 13.9068 17.265 14.0121 16.9998 14.0121C16.7346 14.0121 16.4803 13.9068 16.2928 13.7193Z"
        fill="#565656"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7067 13.7193C23.5191 13.9067 23.2648 14.0121 22.9997 14.0121C22.7345 14.0121 22.4802 13.9067 22.2927 13.7193L19.2927 10.7193C19.1105 10.5307 19.0097 10.2781 19.012 10.0159C19.0143 9.75368 19.1194 9.50287 19.3049 9.31746C19.4903 9.13205 19.7411 9.02688 20.0033 9.0246C20.2655 9.02233 20.5181 9.12312 20.7067 9.30528L23.7067 12.3053C23.8941 12.4928 23.9995 12.7471 23.9995 13.0123C23.9995 13.2774 23.8941 13.5318 23.7067 13.7193Z"
        fill="#565656"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9997 11.0123C20.2649 11.0123 20.5192 11.1177 20.7068 11.3052C20.8943 11.4927 20.9997 11.7471 20.9997 12.0123V20.0123C20.9997 20.2775 20.8943 20.5319 20.7068 20.7194C20.5192 20.9069 20.2649 21.0123 19.9997 21.0123C19.7345 21.0123 19.4801 20.9069 19.2926 20.7194C19.105 20.5319 18.9997 20.2775 18.9997 20.0123V12.0123C18.9997 11.7471 19.105 11.4927 19.2926 11.3052C19.4801 11.1177 19.7345 11.0123 19.9997 11.0123ZM15.7067 18.3053C15.8941 18.4928 15.9995 18.7471 15.9995 19.0123C15.9995 19.2775 15.8941 19.5318 15.7067 19.7193L12.7067 22.7193C12.5181 22.9015 12.2655 23.0023 12.0033 23C11.7411 22.9977 11.4903 22.8925 11.3049 22.7071C11.1194 22.5217 11.0143 22.2709 11.012 22.0087C11.0097 21.7465 11.1105 21.4939 11.2927 21.3053L14.2927 18.3053C14.4802 18.1178 14.7345 18.0125 14.9997 18.0125C15.2648 18.0125 15.5191 18.1178 15.7067 18.3053Z"
        fill="#565656"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29279 18.3053C8.48031 18.1178 8.73462 18.0125 8.99979 18.0125C9.26495 18.0125 9.51926 18.1178 9.70679 18.3053L12.7068 21.3053C12.8023 21.3975 12.8785 21.5079 12.9309 21.6299C12.9833 21.7519 13.0109 21.8831 13.012 22.0159C13.0132 22.1487 12.9879 22.2804 12.9376 22.4033C12.8873 22.5261 12.8131 22.6378 12.7192 22.7317C12.6253 22.8256 12.5136 22.8998 12.3907 22.9501C12.2678 23.0004 12.1362 23.0257 12.0034 23.0245C11.8706 23.0234 11.7394 22.9958 11.6174 22.9434C11.4954 22.891 11.385 22.8148 11.2928 22.7193L8.29279 19.7193C8.10532 19.5318 8 19.2775 8 19.0123C8 18.7471 8.10532 18.4928 8.29279 18.3053Z"
        fill="#565656"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9998 21.0123C11.7345 21.0123 11.4802 20.9069 11.2926 20.7194C11.1051 20.5319 10.9998 20.2775 10.9998 20.0123V12.0123C10.9998 11.7471 11.1051 11.4927 11.2926 11.3052C11.4802 11.1177 11.7345 11.0123 11.9998 11.0123C12.265 11.0123 12.5193 11.1177 12.7069 11.3052C12.8944 11.4927 12.9998 11.747 12.9998 12.0123V20.0123C12.9998 20.2775 12.8944 20.5319 12.7069 20.7194C12.5193 20.9069 12.265 21.0123 11.9998 21.0123Z"
        fill="#565656"
      />
    </svg>
  );

  const activeSvg = (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="32"
        height="32"
        rx="5.5"
        fill="#094C80"
        stroke="#CDCDCD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2928 13.7193C16.1053 13.5318 16 13.2775 16 13.0123C16 12.7471 16.1053 12.4928 16.2928 12.3053L19.2928 9.30529C19.385 9.20978 19.4954 9.1336 19.6174 9.08119C19.7394 9.02878 19.8706 9.00119 20.0034 9.00004C20.1362 8.99888 20.2678 9.02419 20.3907 9.07447C20.5136 9.12475 20.6253 9.199 20.7192 9.29289C20.8131 9.38679 20.8873 9.49844 20.9376 9.62133C20.9879 9.74423 21.0132 9.87591 21.012 10.0087C21.0109 10.1415 20.9833 10.2727 20.9309 10.3947C20.8785 10.5167 20.8023 10.627 20.7068 10.7193L17.7068 13.7193C17.5193 13.9068 17.265 14.0121 16.9998 14.0121C16.7346 14.0121 16.4803 13.9068 16.2928 13.7193Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7068 13.7194C23.5193 13.9068 23.265 14.0122 22.9998 14.0122C22.7346 14.0122 22.4803 13.9068 22.2928 13.7194L19.2928 10.7194C19.1106 10.5308 19.0098 10.2782 19.0121 10.016C19.0144 9.75377 19.1196 9.50296 19.305 9.31755C19.4904 9.13214 19.7412 9.02697 20.0034 9.0247C20.2656 9.02242 20.5182 9.12321 20.7068 9.30537L23.7068 12.3054C23.8943 12.4929 23.9996 12.7472 23.9996 13.0124C23.9996 13.2775 23.8943 13.5318 23.7068 13.7194Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9998 11.0122C20.265 11.0122 20.5194 11.1176 20.7069 11.3051C20.8944 11.4926 20.9998 11.747 20.9998 12.0122V20.0122C20.9998 20.2774 20.8944 20.5318 20.7069 20.7193C20.5194 20.9068 20.265 21.0122 19.9998 21.0122C19.7346 21.0122 19.4802 20.9068 19.2927 20.7193C19.1052 20.5318 18.9998 20.2774 18.9998 20.0122V12.0122C18.9998 11.747 19.1052 11.4926 19.2927 11.3051C19.4802 11.1176 19.7346 11.0122 19.9998 11.0122ZM15.7068 18.3052C15.8943 18.4927 15.9996 18.747 15.9996 19.0122C15.9996 19.2774 15.8943 19.5317 15.7068 19.7192L12.7068 22.7192C12.5182 22.9014 12.2656 23.0022 12.0034 22.9999C11.7412 22.9976 11.4904 22.8924 11.305 22.707C11.1196 22.5216 11.0144 22.2708 11.0121 22.0086C11.0098 21.7464 11.1106 21.4938 11.2928 21.3052L14.2928 18.3052C14.4803 18.1177 14.7346 18.0124 14.9998 18.0124C15.265 18.0124 15.5193 18.1177 15.7068 18.3052Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29279 18.3052C8.48031 18.1178 8.73462 18.0125 8.99979 18.0125C9.26495 18.0125 9.51926 18.1178 9.70679 18.3052L12.7068 21.3052C12.8023 21.3975 12.8785 21.5078 12.9309 21.6298C12.9833 21.7518 13.0109 21.8831 13.012 22.0158C13.0132 22.1486 12.9879 22.2803 12.9376 22.4032C12.8873 22.5261 12.8131 22.6377 12.7192 22.7316C12.6253 22.8255 12.5136 22.8998 12.3907 22.9501C12.2678 23.0003 12.1362 23.0256 12.0034 23.0245C11.8706 23.0233 11.7394 22.9957 11.6174 22.9433C11.4954 22.8909 11.385 22.8147 11.2928 22.7192L8.29279 19.7192C8.10532 19.5317 8 19.2774 8 19.0122C8 18.7471 8.10532 18.4928 8.29279 18.3052Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9998 21.0122C11.7345 21.0122 11.4802 20.9068 11.2926 20.7193C11.1051 20.5318 10.9998 20.2774 10.9998 20.0122V12.0122C10.9998 11.747 11.1051 11.4926 11.2926 11.3051C11.4802 11.1176 11.7345 11.0122 11.9998 11.0122C12.265 11.0122 12.5193 11.1176 12.7069 11.3051C12.8944 11.4926 12.9998 11.747 12.9998 12.0122V20.0122C12.9998 20.2774 12.8944 20.5318 12.7069 20.7193C12.5193 20.9068 12.265 21.0122 11.9998 21.0122Z"
        fill="white"
      />
    </svg>
  );

  return (
    <div
      className="sort-container"
      ref={dropdownRef}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="new-old-filter-button">
        {isOpen ? activeSvg : defaultSvg}
      </div>
      {isOpen && (
        <ul className="options-list sort-options-list">
          {options.map((option, index) => (
            <li
              key={index}
              className={`option-item dk-gray common-text  ${selectedOption === option ? "selected" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                handleOptionClick(option);
              }}
            >
              <span className="check-icon ">
                {selectedOption === option ? "✔" : ""}
              </span>
              {t(option)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Sort;
